import $ from 'cash-dom'

export default class Ad {
  constructor({ $container }) {
    this.$container = $container

    this.constructElements()

    this.constructEvents()

    this.handleAdLoad()
  }

  static init() {
    const $containers = $(Ad.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new Ad({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$adImg = this.$container.find(Ad.selectors.adImg)
    this.$adIframe = this.$container.find(Ad.selectors.adIframe)
    if (this.$container.hasClass(Ad.classes.overlay)) {
      this.$footerOverlay = this.$container.parents(Ad.selectors.footerOverlay)
    }
  }

  constructEvents() {
    if (this.$footerOverlay && this.$footerOverlay.length) {
      this.$footerOverlay
        .on('click', Ad.selectors.footerOverlayCloseButton, (e) => this.handleClickOverlayClose({ e }))
    }

    this.observer = new MutationObserver((mutationList, observer) => this.handleAdChange({ mutationList, observer }))

    this.$container.each((index, element) => {
      this.observer.observe(element, { childList: true, subtree: true })
    })
  }

  doAdHide() {
    this.$container.addClass(Ad.classes.empty)

    if (this.$footerOverlay) {
      this.$footerOverlay.addClass(Ad.classes.footerOverlayClose)
    }
  }

  doAdShow() {
    this.$container.removeClass(Ad.classes.empty)

    if (this.$footerOverlay) {
      this.$footerOverlay.removeClass(Ad.classes.footerOverlayClose)
    }
  }

  doCheckAdContents() {
    this.$item.removeClass(Ad.classes.active)

    this.$wrap.removeAttr('style')
  }

  doOverlayClose() {
    if (this.$footerOverlay && this.$footerOverlay.length) {
      this.$footerOverlay.addClass(Ad.classes.footerOverlayClose)
    }
  }

  handleAdLoad() {
    // check for empty ad slot on load
    if (this.$adIframe.length || this.$adImg.length) {
      this.doAdShow()
    } else {
      this.doAdHide()
    }
  }

  handleAdChange({ mutationList, observer}) {
    const $adIframes = this.$container.find(Ad.selectors.adIframe)
    const $adImages = this.$container.find(Ad.selectors.adImg)
    
    if ($adIframes.length || $adImages.length) {
      this.doAdShow()
    } else {
      this.doAdHide()
    }
  }

  handleClickOverlayClose() {
    this.doOverlayClose()
  }
}

Ad.selectors = {
  container: '.js-ad',
  footerOverlay: '.js-ad-footer',
  footerOverlayCloseButton: '.js-ad-overlay-close-button',
  adImg: '.js-ad-img',
  adIframe: 'iframe[aria-label="Advertisement"]',
}

Ad.classes = {
  empty: 'o-ad--empty',
  overlay: 'o-ad--overlay',
  footerOverlayClose: 'c-main-footer__ad-overlay--closed',
}
